import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, ShieldIcon, LockIcon } from 'lucide-react';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: ShieldIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}];
function easeInOutCubic(t: number) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function slowScrollTo(targetId: string, duration = 1800) {
  const el = document.getElementById(targetId);
  if (!el) return;
  const startY = window.scrollY;
  const targetY = el.getBoundingClientRect().top + startY;
  const distance = targetY - startY;
  const startTime = performance.now();
  function step(now: number) {
    const elapsed = now - startTime;
    const t = Math.min(elapsed / duration, 1);
    const eased = easeInOutCubic(t);
    window.scrollTo(0, startY + distance * eased);
    if (t < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
export function Hero() {
  return <section className="relative overflow-hidden text-white px-5 pt-10 pb-20 text-center" style={{
    background: 'linear-gradient(160deg, #0f1e3d 0%, #1a2f5e 60%, #1e3a6e 100%)'
  }} data-id="element-77">
      {/* decorative gold corner glow */}
      <div aria-hidden className="pointer-events-none absolute -top-16 -right-16 w-[300px] h-[300px] rounded-full" style={{
      background: 'rgba(240,192,64,0.06)'
    }} data-id="element-78" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative" data-id="element-79">
        <div className="inline-block border border-gold/40 bg-gold/15 text-gold text-[10px] tracking-[0.15em] uppercase px-4 py-1.5 rounded-full mb-6" data-id="element-80">
          CHERUB AGENCY™
        </div>

        <h1 className="font-serif font-normal mx-auto mb-2 max-w-[780px] text-white text-[24px]" data-id="element-81">
          Tu bebé no vino con manual.
          <br data-id="element-82" />
          <em className="not-italic text-gold" data-id="element-83">Nosotros sí te lo damos.</em>
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="my-4 max-w-[480px] mx-auto" data-id="element-84">
          <img src="https://cdn.magicpatterns.com/uploads/tYNCNzPHQbQ935WfMx3gMW/2265f319-4af1-483d-8c5f-585e214fc786.png" alt="Cherub Agency Bundle" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.3)]" data-id="element-85" />
        </motion.div>

        <p className="italic text-white/80 max-w-[620px] mx-auto mb-8 text-[clamp(0.95rem,2.2vw,1.15rem)] leading-relaxed" data-id="element-86">
          El sistema completo para entender cada necesidad de tu bebé,
          <br className="hidden sm:block" data-id="element-87" /> recuperar el descanso y criar con
          calma y total seguridad de 0 a 12 meses.
        </p>

        <div className="flex flex-nowrap justify-center gap-2.5 sm:gap-6 mb-9 px-2" data-id="element-88">
          {badges.map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex items-center gap-1 text-white/75 text-[0.7rem] sm:text-[0.82rem]" data-id="element-89">
              <Icon className="w-3 h-3 sm:w-4 sm:h-4 text-gold" data-id="element-90" />
              {label}
            </div>)}
        </div>

        <a href="#oferta" onClick={e => {
        e.preventDefault();
        slowScrollTo('oferta', 1800);
      }} className="inline-block font-serif font-bold text-navy text-[1.05rem] px-11 py-[18px] rounded-md tracking-wide transition-all duration-200 hover:-translate-y-0.5 cursor-pointer" style={{
        background: 'linear-gradient(135deg, #f0c040 0%, #e8a820 100%)',
        boxShadow: '0 8px 32px rgba(240,192,64,0.35)'
      }} data-id="element-91">
          → QUIERO ENTENDER A MI BEBÉ HOY
        </a>

        <span className="block text-white/55 text-[0.78rem] mt-3 text-center" data-id="element-92">
          · Acceso inmediato · Sin suscripciones
        </span>
      </motion.div>
    </section>;
}